// inputs.js
import { validateRequired,validateLength, validateNonZeroInteger  }from "../../../../helpers/validationsForm";

const Inputs = [
  {
    id: 1,
    label: "Codigo",
    name: "codigo_ramo",
    type: "text", // Cambié a "text" para poder hacer la validación manualmente
    placeholder: "Ingrese el codigo",
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateRequired(value);
      if (requiredError) {
        return requiredError;
      }
    
      return null;
    } 
  },
  {
    id: 2,
    label: "Descripcion",
    name: "descripcion_ramo",
    type: "text",
    placeholder: "Ingrese la descripcion",
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateRequired(value);
      if (requiredError) {
        return requiredError;
      }
    
      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 3, maxLength: 40 });
      if (lengthError) {
        return lengthError;
      }
    
      // Si no hay errores
      return null;
    } 
  }, 
  {
    id: 3,
    label: "Mostrar en Web",
    name: "ramo_show_web",
    type: "select",
    options: [
      { value: 0, label: 'Visible' },
      { value: 1, label: 'Oculto' },
    ],
    placeholder: "Ingrese el tipo de visualización",
  },
   {
    id: 4,
    label: "Mostrar en App",
    name: "ramo_show_app",
    type: "select",
    options: [
      { value: 0, label: 'Visible' },
      { value: 1, label: 'Oculto' },
    ],
    placeholder: "Ingrese el tipo de visualización",
  },
];

export default Inputs;
